import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  gap: ${(p) => p.theme.spacing(1)};
`;
